import { render, staticRenderFns } from "./SystemAdmin.vue?vue&type=template&id=16160cf0&scoped=true"
import script from "./SystemAdmin.vue?vue&type=script&lang=js"
export * from "./SystemAdmin.vue?vue&type=script&lang=js"
import style0 from "./SystemAdmin.vue?vue&type=style&index=0&id=16160cf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16160cf0",
  null
  
)

export default component.exports